var React = require('react');

function Clipboard (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 1)"},[React.createElement("path",{"data-name":"Tracé 12","d":"M16,4h2a2,2,0,0,1,2,2V20a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H8","transform":"translate(-4 -2)","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("rect",{"data-name":"Rectangle 32","width":"8","height":"4","rx":"1","transform":"translate(4)","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Clipboard.defaultProps = {"width":"18","height":"22","viewBox":"0 0 18 22"};

module.exports = Clipboard;

Clipboard.default = Clipboard;
